import {
  Button,
  FormInput,
  FormPassword,
  FormRoot,
  RHF,
  zodResolver,
} from "@devhop/ui";
import { z } from "zod";

const EditStaffFormSchema = z.object({
  email: z.string().email("ກະລຸນາໃສ່ອີເມວໃຫ້ຖືກຕ້ອງ"),
  name: z.string().min(1, "ຕ້ອງໃສ່ຊື່"),
  password: z
    .string()
    .refine(
      (value) => value.length === 0 || value.length >= 6,
      "ລະຫັດຜ່ານຕ້ອງຢ່າງນ້ອຍ 6 ຕົວອັກສອນ",
    )
    .optional(),
});

export type EditStaffFormValues = z.infer<typeof EditStaffFormSchema>;

export function EditStaffForm({
  initialValues,
  onSubmit,
  submitting,
}: {
  initialValues: Pick<EditStaffFormValues, "email" | "name">;
  onSubmit: (values: EditStaffFormValues) => void;
  submitting?: boolean;
}) {
  const methods = RHF.useForm<EditStaffFormValues>({
    resolver: zodResolver(EditStaffFormSchema),
    defaultValues: {
      email: initialValues.email,
      name: initialValues.name,
      password: "",
    },
  });

  return (
    <FormRoot<EditStaffFormValues>
      methods={methods}
      onSubmit={(vals) =>
        onSubmit({
          email: vals.email,
          name: vals.name,
          password: vals.password || undefined,
        })
      }
      className="space-y-4"
    >
      <FormInput
        name="email"
        label="ອີເມວ"
        type="email"
        requiredMark
        placeholder="name@example.com"
      />
      <FormInput name="name" label="ຊື່" requiredMark placeholder="ຊື່ພະນັກງານ" />
      <FormPassword
        name="password"
        label="ລະຫັດຜ່ານໃໝ່"
        placeholder="ປ່ອຍວ່າງຖ້າບໍ່ຕ້ອງການປ່ຽນ"
      />
      <div className="flex justify-end gap-2 pt-2">
        <Button type="submit" isLoading={submitting}>
          ບັນທຶກ
        </Button>
      </div>
    </FormRoot>
  );
}
